<template>
  <div class="catalogue-list">
    <v-card >

        <v-app-bar flat >
          <v-toolbar-title class="title pl-1">
            {{$t('designfile.designfiles')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="ml-sm-2"
            color="primary"
            @click="orderaction"
          >
            {{ $t('order.orderaction')}}
          </v-btn>
          <!--
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn> !-->
        </v-app-bar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="3" v-for="designfile in designfiles" :key="designfile.id">
              <v-card class="black" width="220" min-width="200">
                <v-img
                  height="150"
                  @click="showHandler(designfile)"
                  class="white--text align-end cursorpointer"
                  lazy-src="@/assets/3dfile.png"
                  :key="componentKey"
                  :src="getImageUrlByObject(designfile)"
                >
                   <v-card-title v-text="designfile.name"></v-card-title>
                 </v-img>

                 <v-card-actions>
                   <span class="d-inline-block text-truncate">{{ designfile.ref }}</span>
                   <v-spacer></v-spacer>
                   <v-btn icon  @click="addHandlerSub('Order',designfile)">
                     <v-icon>mdi-basket-fill</v-icon>
                   </v-btn>
                   <v-btn v-if="designfile['file']" icon @click="downloadFileList(designfile['id'],designfile['@entity'],designfile['file'].filePath)">
                     <v-icon>mdi-download</v-icon>
                   </v-btn>
                 </v-card-actions>
               </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'DesignFileList',
  servicePrefix: 'DesignFile',
  mixins: [ListMixin,FileMixin],
  components: {

  },
  data() {
    return {
      filter: '150x150',
      ...mapState('designfile',{allIds:'allIds'}),
    };
  },
  mounted() {
      this.getDesignFiles({'type.production': 1,'itemsPerPage': '500','order[id]': 'desc'})
  },
  computed: {
    sizecol() {
      if (this.sub) return 4
      else return 3
    },
    ...mapGetters('designfile', {
      designfiles: 'list'
    }),
    ...mapFields('designfile', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('designfile', {
      getDesignFiles: 'fetchAll'
    }),
    orderaction() {
      this.$router.push({ name: `OrderCreate` });
    }

  }
};
</script>
